const colors = {
	primary: "#FF6060",
	secondary: "#8186A0",
	backgroundLight: "#F9F9FC",
};

export default colors;
